var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import Tag from './';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider';
const TagList = (_a) => {
    var { prefixCls: customizePrefixCls, type = '', tagDatas = [], className } = _a, restProps = __rest(_a, ["prefixCls", "type", "tagDatas", "className"]);
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('tag-list', customizePrefixCls);
    const showBorder = type === 'outline';
    const showEnhance = type === 'enhance';
    return (<>
            {tagDatas.map((item, index) => {
            const { color, bgColor, border: bColor, icon: iconDom = null, text } = item;
            const tagStyle = Object.assign(Object.assign(Object.assign({}, (color ? { color } : {})), (bgColor ? { backgroundColor: bgColor } : {})), (bColor ? { border: `1px solid ${bColor}` } : {}));
            const i = index % 10;
            const isBorder = showBorder && !bColor;
            return (<Tag key={index} {...(type ? { type } : {})} style={tagStyle} className={classNames({
                    [`${prefixCls}-order-color-${i + 1}`]: !showEnhance && !color,
                    [`${prefixCls}-order-bg-color-${i + 1}`]: !showEnhance && !bgColor,
                    [`${prefixCls}-order-bg-color-${i + 1}-enhance`]: showEnhance && !bgColor,
                    [`${prefixCls}-order-border-color-${i + 1}`]: isBorder,
                }, className)} icon={iconDom} {...restProps}>
                            {text}
                        </Tag>);
        })}
        </>);
};
export default TagList;
